<app-feature-details-grid>
  <app-feature-list-container>
    <!-- device manufacturer -->
    <app-feature-list-item
      *ngrxLet="deviceThirdpartyManufacturer$ as feature"
      data-at-device-manufacturer
      label="{{ '+INSTALLATIONS.INSTALLATION.DEVICE_MANUFACTURER' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }}"
      [attr.data-feature]="FeatureNames.deviceThirdpartyManufacturer"
    >
    </app-feature-list-item>
    <!-- device model -->
    <app-feature-list-item
      *ngrxLet="deviceThirdpartyModel$ as feature"
      data-at-device-model
      label="{{ '+INSTALLATIONS.INSTALLATION.DEVICE_MODEL' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }}"
      [attr.data-feature]="FeatureNames.deviceThirdpartyModel"
    >
    </app-feature-list-item>
    <!-- device firmware -->
    <app-feature-list-item
      *ngrxLet="deviceThirdpartySoftware$ as feature"
      data-at-device-firmware
      label="{{ '+INSTALLATIONS.INSTALLATION.DEVICE_FIRMWARE' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }}"
      [attr.data-feature]="FeatureNames.deviceThirdpartySoftware"
    >
    </app-feature-list-item>
    <!-- device serial -->
    <app-feature-list-item
      *ngrxLet="deviceEtn$ as feature"
      data-at-serial-number
      label="{{ '+INSTALLATIONS.INSTALLATION.DEVICE_SERIAL_NUMBER' | translate }}:"
      value="{{ feature | value2: featurePropertyKey.value }}"
      [attr.data-feature]="FeatureNames.deviceEtn"
    >
    </app-feature-list-item>
  </app-feature-list-container>

  <ng-container *ngrxLet="sessionCharging$ as sessionCharging" feature>
    <app-feature-list-container>
      <!-- charging power -->
      <app-feature-list-item
        *ngrxLet="chargingPower$ as feature"
        data-at-charging-power
        label="{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_POWER' | translate }}:"
        value="{{ feature | value2: featurePropertyKey.value }} {{ feature | unit: 'value' }} {{
          phaseLabel
        }}"
        [attr.data-feature]="FeatureNames.wallboxDisplayedPower"
      >
      </app-feature-list-item>
      <!-- charging status -->
      <ng-container
        *ngrxLet="{ status: displayedStatus$, subStatus: displayedSubStatus$ } as feature"
      >
        <app-feature-list-item
          data-at-charging-status
          label="{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_STATUS' | translate }}:"
          value="{{
            chargingTranslationKey +
              (feature.status | value2: featurePropertyKey.status | uppercase) | translate
          }} {{ feature.subStatus ? (displayedStatusDescription | translate) : '' }}"
          [attr.data-feature]="FeatureNames.wallboxDisplayedStatus + '/status.value'"
        >
        </app-feature-list-item>
      </ng-container>
      <!-- charging session -->
      <app-feature-list-item
        data-at-charging-session
        label="{{
          '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGED_ENERGY_IN_CURRENT_SESSION' | translate
        }}:"
        value="{{ sessionCharging | value2: featurePropertyKey.energy }} {{
          sessionCharging | unit: 'energy'
        }}"
        [attr.data-feature]="FeatureNames.wallboxSessionCharging"
      >
      </app-feature-list-item>
      <!-- charging time -->
      <app-feature-list-item
        data-at-charging-time
        label="{{ '+INSTALLATIONS.INSTALLATION.WALLBOX.CHARGING_TIME' | translate }}:"
        value="{{ sessionCharging?.properties?.time?.value | secondsTimeFormatter: 'HH:mm' }} {{
          sessionCharging?.properties?.time?.value ? SUFFIX.hour : null
        }}"
        [attr.data-feature]="FeatureNames.wallboxSessionCharging + '/time'"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </ng-container>
</app-feature-details-grid>
